import { CodeMarkdownPreprocessorExtension } from '@blocksuite/hive-block-code';
import { LatexMarkdownPreprocessorExtension } from '@blocksuite/hive-block-latex';

export const defaultMarkdownPreprocessors = [
  LatexMarkdownPreprocessorExtension,
  CodeMarkdownPreprocessorExtension,
];
